import { render, staticRenderFns } from "./landTransfer.vue?vue&type=template&id=98b52b9e&scoped=true&"
import script from "./landTransfer.vue?vue&type=script&lang=js&"
export * from "./landTransfer.vue?vue&type=script&lang=js&"
import style0 from "./landTransfer.vue?vue&type=style&index=0&id=98b52b9e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b52b9e",
  null
  
)

export default component.exports